module.exports = __webpack_public_path__ + "media/members/print_roster-b8dca9f6.png";